import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useForm, useWatch, useFieldArray } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';

import OnOffByScroll from '../../../Animation/onOffByScroll';
import { AuthContext } from '../../../auth';
import various from '../../../General/various';
import {
  instructorDetailForAdmin,
  instructorPaymentMethodUpdate,
  getInstructorAllPaymentMethods,
} from '../../../Apis/apiOfManaged';
import { selectDefaultCheck } from '../../../CommonFunction/validators';
import Footer from '../../../Footer/footer';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  titles: {},
  inputs: {},
  helptext: {},
  error: {
    color: 'red',
    fontSize: '0.7em',
  },
  container: {
    marginTop: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media screen and (max-width:800px)': {
      '& > div': {
        width: '100%',
      },
    },
    '& > form': {
      '& > h4': {
        '& > span': {
          fontSize: '2rem',
          fontWeight: 'bold',
          color: theme.palette.primary.main,
        },
      },
      '& > div': {
        width: '70%',
        display: 'flex',
        margin: '0 auto',
        marginBottom: '32px',

        '& > div': {
          textAlign: 'start',
          display: 'flex',
          justifyContent: 'start',
          '& > img': {
            maxWidth: '300px',
            maxHeight: '300px',
            objectFit: 'contain',
          },
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
        },

        '& $titles': {
          width: '30%',
          marginRight: '32px',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > label': {
            width: '100%',
            textAlign: 'end',
            fontSize: '1rem',
            '@media screen and (max-width:750px)': {
              textAlign: 'start',
              marginBottom: '16px',
            },
          },
          '& > span': {
            color: 'red',
          },
        },

        '& $inputs': {
          width: '70%',
          flexWrap: 'wrap',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > input, & > textarea, & > select': {
            width: '100%',
            height: '40px',
            padding: '8px',
            fontFamily: theme.typography.fontFamily,
            border: '0.5px solid grey',
            borderRadius: '0.5em',
            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
            '&:focus': {
              outline: `1.2px ${theme.palette.primary.main} outset`,
            },
          },
          '& > textarea': {
            minHeight: '160px',
          },
          '& > input[type="checkbox"]': {
            boxShadow: 'none',
          },
          '& $helptext': {
            fontSize: '0.8rem',
            color: 'grey',
            '& > a': {
              textDecoration: 'underline',
              '&:link': {
                color: theme.palette.primary.main,
              },
            },
          },
        },

        '@media screen and (max-width:750px)': {
          flexWrap: 'wrap',
        },
      },
    },
  },
  button: {
    width: '100%',
    marginTop: '88px !important',
    justifyContent: 'end',
    '& > button': {
      width: '100%',
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      borderRadius: '0.5em',
      border: 'none',
      padding: '4px 8px',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
      color: '#fff',
      cursor: 'pointer',
    },
  },
}));

const InstructorPaymentMethodUpdate = () => {
  const {
    control,
    register,
    reset,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      bank_accounts: [], // 配列で初期化
      paypay_accounts: [],
      payment_links_accounts: [],
      stripe_account: {
        business_website_url: '',
        tokushoho_url: '',
        // api_secret_key: '', // もし必要ならここに追加
      },
    },
  });
  const {
    fields: bankFields,
    // append: bankAppend,
    // remove: bankRemove,
  } = useFieldArray({
    control,
    name: 'bank_accounts',
  });
  const {
    fields: paypayFields,
    // append: paypayAppend,
    // remove: paypayRemove,
  } = useFieldArray({
    control,
    name: 'paypay_accounts',
  });
  const {
    fields: paymentLinksFields,
    // append: paymentLinksAppend,
    // remove: paymentLinksRemove,
  } = useFieldArray({
    control,
    name: 'payment_links_accounts',
  });

  const { isAuth } = useContext(AuthContext);
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const [date, setDate] = useState();
  // eslint-disable-next-line
  const [instructor, setInstructor] = useState();

  const [paymentMethods, setPaymentMethods] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const searchParams = new URLSearchParams(location.search);
  const instructor_uuid =
    (location.state && location.state.uuid) || searchParams.get('uuid'); // ← uuidキーの値を取得

  const CRUMBS = [
    location?.state?.previous !== '/manage/instructor_settings_for_instructor'
      ? { name: '管理画面Top', path: '/manage/index' }
      : '',
    location?.state?.previous === '/manage/instructor_settings_for_instructor'
      ? {
          name: '指導者設定',
          path: '/manage/instructor_settings_for_instructor',
        }
      : { name: '指導者一覧', path: '/manage/instructor_index' },
    { name: '決済方法更新', path: '/manage/instructor_payment_method_update' },
  ];

  // if (instructor) console.log('instructor', instructor);
  // if (paymentMethods) console.log('paymentMethods', paymentMethods);
  // if (bankFields && bankFields.length > 0)
  //   console.log('bankFields', bankFields);
  // if (paypayFields && paypayFields.length > 0)
  //   console.log('paypayFields', paypayFields);

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    if (instructor_uuid) {
      instructorDetailForAdmin(setInstructor, instructor_uuid);
      getInstructorAllPaymentMethods(setPaymentMethods, instructor_uuid);
    }
  }, [instructor_uuid]);

  useEffect(() => {
    if (
      paymentMethods &&
      paymentMethods.bank_accounts &&
      paymentMethods.paypay_accounts &&
      paymentMethods.payment_links_accounts
    ) {
      // console.log('paymentMethods in useEffect', paymentMethods);

      // StripeAccountを抜き出す
      let stripeAccountData = {
        business_website_url: '',
        tokushoho_url: '',
      };

      if (paymentMethods.payment_links_accounts.length > 0) {
        stripeAccountData = {
          business_website_url:
            paymentMethods.payment_links_accounts[0].business_website_url || '',
          tokushoho_url:
            paymentMethods.payment_links_accounts[0].tokushoho_url || '',
        };
      }

      // Formの初期値をセット
      reset({
        bank_accounts: paymentMethods.bank_accounts || [],
        paypay_accounts: paymentMethods.paypay_accounts || [],
        payment_links_accounts: paymentMethods.payment_links_accounts || [],
        stripe_account: stripeAccountData,
      });
    }
  }, [paymentMethods, reset]);

  // Submit
  const onSubmit = handleSubmit(async (data) => {
    const payload = {
      instructor: instructor_uuid,
      bank_accounts: data.bank_accounts,
      paypay_accounts: data.paypay_accounts,
      payment_links_accounts: data.payment_links_accounts,
      stripe_account: data.stripe_account,
    };
    // console.log('onSubmit payload', payload);
    try {
      await instructorPaymentMethodUpdate(payload);
      console.log('update finish!');
      navigate(location.state.previous, {
        state: { previous: location.pathname, uuid: instructor_uuid },
      });
    } catch (error) {
      console.error('Error in payment method update:', error);
    }
  });

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  // Contents
  const bankForm = (bankFields) => {
    return bankFields.map((bank, index) => {
      return (
        <React.Fragment key={`bank_${index}`}>
          <h4>
            銀行口座 <span>{index + 1}</span>
          </h4>
          <div>
            <div className={classes.titles}>
              <label htmlFor="bank_account">銀行口座</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.bank_name`}
                type="text"
                {...register(`bank_accounts.${index}.bank_name`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 100,
                    message: '100文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>銀行名を入力してください。</div>
              {errors[`bank_accounts.${index}.bank_name`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.bank_name`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="branch_name">支店名</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.branch_name`}
                type="text"
                {...register(`bank_accounts.${index}.branch_name`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 100,
                    message: '100文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>支店名を入力してください。</div>
              {errors[`bank_accounts.${index}.branch_name`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.branch_name`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="account_number">口座番号</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.account_number`}
                type="text"
                {...register(`bank_accounts.${index}.account_number`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 20,
                    message: '20文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                口座番号を入力してください。
              </div>
              {errors[`bank_accounts.${index}.account_number`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.account_number`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="account_holder">講座名義人</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.account_holder`}
                type="text"
                {...register(`bank_accounts.${index}.account_holder`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 100,
                    message: '100文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                講座名義人を入力してください。
              </div>
              {errors[`bank_accounts.${index}?.account_holder`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.account_holder`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="account_type">口座種別</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <select
                id={`bank_accounts.${index}.account_type`}
                defaultValue="choice"
                {...register(`bank_accounts.${index}.account_type`, {
                  required: { value: true, message: '入力必須の項目です' },
                  validate: {
                    message: (v) =>
                      selectDefaultCheck(v)
                        ? null
                        : `口座種別を選択してください。`,
                  },
                })}
              >
                <option value="choice">選択してください</option>
                <option value="ordinary">普通</option>
                <option value="checking">当座</option>
              </select>
              <div className={classes.helptext}>
                口座種別を選択してください。
              </div>
              {errors[`bank_accounts.${index}.account_type`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.account_type`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="memo">案内事項</label>
            </div>
            <div className={classes.inputs}>
              <textarea
                id={`bank_accounts.${index}.memo`}
                {...register(`bank_accounts.${index}.memo`, {
                  required: { value: false, message: '入力必須の項目です' },
                  maxLength: {
                    value: 500,
                    message: '500文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                口座に関する案内事項を入力してください。ここに記載する内容はセミナー参加者が決済行動を適切に行うための注意事項として記載してください（任意）。
              </div>
              {errors[`bank_accounts.${index}.memo`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.memo`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_default">デフォルト口座に設定</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.is_default`}
                type="checkbox"
                {...register(`bank_accounts.${index}.is_default`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済方法をデフォルトにする場合はチェックを入れてください。なお、デフォルト設定は”決済方法毎”に設定されます。たとえば銀行口座のデフォルト口座があり、PayPay口座のデフォルト口座があるということです。また、デフォルト口座は決済方法毎に”一つだけ”設定できます。たとえば、銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
              </div>
              {errors[`bank_accounts.${index}.is_default`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.is_default`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_active">運用中</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`bank_accounts.${index}.is_active`}
                type="checkbox"
                {...register(`bank_accounts.${index}.is_active`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済方法を運用するのであればチェックを入れてください。使わない場合はチェックを外してください。
              </div>
              {errors[`bank_accounts.${index}.is_active`]?.message && (
                <div className={classes.error}>
                  {errors[`bank_accounts.${index}.is_active`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.inputs}>
              <input
                type="hidden"
                {...register(`bank_accounts.${index}.uuid`)}
              />
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    });
  };

  const paypayForm = (paypayFields) => {
    return paypayFields.map((paypay, index) => {
      return (
        <React.Fragment key={`paypay_${index}`}>
          <h4>
            PayPay口座 <span>{index + 1}</span>
          </h4>
          <div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.account_holder`}
                type="hidden"
                {...register(`paypay_accounts.${index}.account_holder`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 100,
                    message: '100文字以内でお願いします',
                  },
                })}
              />
            </div>
          </div>
          <div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.paypay_email`}
                type="hidden"
                {...register(`paypay_accounts.${index}.paypay_email`, {
                  required: { value: true, message: '入力必須の項目です' },
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: '有効なメールアドレスを入力してください',
                  },
                })}
              />
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="paypay_id">PayPay ID</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.paypay_id`}
                type="text"
                {...register(`paypay_accounts.${index}.paypay_id`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 50,
                    message: '50文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                PayPayに登録されているIDを入力してください。
              </div>
              {errors[`paypay_accounts.${index}.paypay_id`]?.message && (
                <div className={classes.error}>
                  {errors[`paypay_accounts.${index}.paypay_id`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="support_page_url">サポートページURL</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.support_page_url`}
                type="url"
                defaultValue={'https://paypay.ne.jp/guide/send/'}
                {...register(`paypay_accounts.${index}.support_page_url`, {
                  required: { value: true, message: '入力必須の項目です' },
                  pattern: {
                    value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                    message: '有効なURLを入力してください',
                  },
                })}
              />
              <div className={classes.helptext}>
                セミナー参加者が迷わないように、適切なPayPayのサポートページ（支払方法）のURLを入力してください。
              </div>
              {errors[`paypay_accounts.${index}.support_page_url`]?.message && (
                <div className={classes.error}>
                  {errors[`paypay_accounts.${index}.support_page_url`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="memo">案内事項</label>
            </div>
            <div className={classes.inputs}>
              <textarea
                id={`paypay_accounts.${index}.memo`}
                {...register(`paypay_accounts.${index}.memo`, {
                  required: { value: false, message: '入力必須の項目です' },
                  maxLength: {
                    value: 500,
                    message: '500文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                口座に関する案内事項を入力してください。ここに記載する内容はセミナー参加者が決済行動を適切に行うための注意事項として記載してください（任意）。
              </div>
              {errors[`paypay_accounts.${index}.memo`]?.message && (
                <div className={classes.error}>
                  {errors[`paypay_accounts.${index}.memo`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_default">デフォルト口座に設定</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.is_default`}
                type="checkbox"
                {...register(`paypay_accounts.${index}.is_default`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済方法をデフォルトにする場合はチェックを入れてください。なお、デフォルト設定は”決済方法毎”に設定されます。たとえば銀行口座のデフォルト口座があり、PayPay口座のデフォルト口座があるということです。また、デフォルト口座は決済方法毎に”一つだけ”設定できます。たとえば、銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
              </div>
              {errors[`paypay_accounts.${index}.is_default`]?.message && (
                <div className={classes.error}>
                  {errors[`paypay_accounts.${index}.is_default`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_active">運用中に設定</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`paypay_accounts.${index}.is_active`}
                type="checkbox"
                {...register(`paypay_accounts.${index}.is_active`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済方法を運用するのであればチェックを入れてください。使わない場合はチェックを外してください。
              </div>
              {errors[`paypay_accounts.${index}.is_active`]?.message && (
                <div className={classes.error}>
                  {errors[`paypay_accounts.${index}.is_active`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.inputs}>
              <input
                type="hidden"
                {...register(`paypay_accounts.${index}.uuid`)}
              />
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    });
  };

  const paymentLinksForm = (paymentLinksFields) => {
    return paymentLinksFields.map((paymentLink, index) => {
      return (
        <React.Fragment key={`payment_link_${index}`}>
          <h4>
            PaymentLinks口座 <span>{index + 1}</span>
          </h4>
          <div>
            <div className={classes.inputs}>
              <input
                id={`payment_links_accounts.${index}.account_holder`}
                type="hidden"
                {...register(`payment_links_accounts.${index}.account_holder`, {
                  required: { value: true, message: '入力必須の項目です' },
                  maxLength: {
                    value: 100,
                    message: '100文字以内でお願いします',
                  },
                })}
              />
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="url">リンクURL</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`payment_links_accounts.${index}.url`}
                type="url"
                {...register(`payment_links_accounts.${index}.url`, {
                  required: { value: true, message: '入力必須の項目です' },
                  pattern: {
                    value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                    message: '有効なURLを入力してください',
                  },
                })}
              />
              <div className={classes.helptext}>
                Stripeダッシュボード上で生成したPaymentLinksの支払いURLを入力してください。
              </div>
              {errors[`payment_links_accounts.${index}.url`]?.message && (
                <div className={classes.error}>
                  {errors[`payment_links_accounts.${index}.url`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="amount">決済金額</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id={`payment_links_accounts.${index}.amount`}
                type="number"
                {...register(`payment_links_accounts.${index}.amount`, {
                  required: { value: true, message: '入力必須の項目です' },
                  min: {
                    value: 0,
                    message: '0以上の金額を入力してください',
                  },
                })}
              />
              <div className={classes.helptext}>
                PaymentLinksの支払いURLを生成した際に設定した金額を入力してください。
              </div>
              {errors[`payment_links_accounts.${index}.amount`]?.message && (
                <div className={classes.error}>
                  {errors[`payment_links_accounts.${index}.amount`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="memo">案内事項</label>
            </div>
            <div className={classes.inputs}>
              <textarea
                id={`payment_links_accounts.${index}.memo`}
                {...register(`payment_links_accounts.${index}.memo`, {
                  required: { value: false, message: '入力必須の項目です' },
                  maxLength: {
                    value: 500,
                    message: '500文字以内でお願いします',
                  },
                })}
              />
              <div className={classes.helptext}>
                決済リンクに関する案内事項を入力してください。ここに記載する内容はセミナー参加者が決済行動を適切に行うための注意事項として記載してください（任意）。
              </div>
              {errors[`payment_links_accounts.${index}.memo`]?.message && (
                <div className={classes.error}>
                  {errors[`payment_links_accounts.${index}.memo`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_default">デフォルトリンクに設定</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`payment_links_accounts.${index}.is_default`}
                type="checkbox"
                {...register(`payment_links_accounts.${index}.is_default`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済リンクをデフォルトにする場合はチェックを入れてください。
                なお、デフォルト設定は”決済方法毎”に設定されます。
                たとえば銀行口座のデフォルト口座があり、PayPay口座のデフォルト口座があるということです。
                また、デフォルトリンクは決済方法毎に”一つだけ”設定できます。
                たとえば、銀行口座を複数登録した場合、どの口座をデフォルトにするかを選択してください。
              </div>
              {errors[`payment_links_accounts.${index}.is_default`]
                ?.message && (
                <div className={classes.error}>
                  {errors[`payment_links_accounts.${index}.is_default`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="is_active">運用中に設定</label>
            </div>
            <div className={classes.inputs}>
              <input
                id={`payment_links_accounts.${index}.is_active`}
                type="checkbox"
                {...register(`payment_links_accounts.${index}.is_active`, {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              <div className={classes.helptext}>
                この決済リンクを運用するのであればチェックを入れてください。使わない場合はチェックを外してください。
              </div>
              {errors[`payment_links_accounts.${index}.is_active`]?.message && (
                <div className={classes.error}>
                  {errors[`payment_links_accounts.${index}.is_active`].message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.inputs}>
              <input
                type="hidden"
                {...register(`payment_links_accounts.${index}.uuid`)}
              />
            </div>
          </div>
          <hr />
          {index === paymentLinksFields.length - 1 && (
            <>
              <h4>Stripe Account</h4>
              <div>
                <div className={classes.titles}>
                  <label htmlFor="stripe_account.business_website_url">
                    ビジネスウェブサイトURL
                  </label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="stripe_account.business_website_url"
                    type="url"
                    {...register('stripe_account.business_website_url', {
                      required: {
                        value: true,
                        message: '入力必須の項目です',
                      },
                      pattern: {
                        value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                        message: '有効なURLを入力してください',
                      },
                    })}
                  />
                  <div className={classes.helptext}>
                    ビジネスウェブサイトのURLを入力してください。
                  </div>
                  {errors.stripe_account?.business_website_url?.message && (
                    <div className={classes.error}>
                      {errors.stripe_account.business_website_url.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor="stripe_account.tokushoho_url">
                    特商法ページURL
                  </label>
                  <span> *</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="stripe_account.tokushoho_url"
                    type="url"
                    {...register('stripe_account.tokushoho_url', {
                      required: {
                        value: true,
                        message: '入力必須の項目です',
                      },
                      pattern: {
                        value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                        message: '有効なURLを入力してください',
                      },
                    })}
                  />
                  <div className={classes.helptext}>
                    特定商取引法に基づく表記のページURLを入力してください。
                  </div>
                  {errors.stripe_account?.tokushoho_url?.message && (
                    <div className={classes.error}>
                      {errors.stripe_account.tokushoho_url.message}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      );
    });
  };

  // 動的バリデーション -> 口座が追加されたら適宜バリデーション処理も追加すること
  // ここでは「is_default」が、Account毎に1つだけ選択されているかをチェックする
  const bankAccounts = useWatch({ control, name: 'bank_accounts' });
  const paypayAccounts = useWatch({ control, name: 'paypay_accounts' });
  const paymentLinksAccounts = useWatch({
    control,
    name: 'payment_links_accounts',
  });

  useEffect(() => {
    if (!bankAccounts) return;
    const count = bankAccounts.filter((a) => a && a.is_default).length;
    if (count > 0 && count !== 1) {
      setError('bank_accounts', {
        type: 'manual',
        message: '銀行口座のデフォルトは1つだけ選択してください。',
      });
    } else {
      clearErrors('bank_accounts');
    }
  }, [bankAccounts, setError, clearErrors]);

  useEffect(() => {
    if (!paypayAccounts) return;
    const count = paypayAccounts.filter((a) => a && a.is_default).length;
    if (count > 0 && count !== 1) {
      setError('paypay_accounts', {
        type: 'manual',
        message: 'PayPay口座のデフォルトは1つだけ選択してください。',
      });
    } else {
      clearErrors('paypay_accounts');
    }
  }, [paypayAccounts, setError, clearErrors]);

  useEffect(() => {
    if (!paymentLinksAccounts) return;
    const count = paymentLinksAccounts.filter((a) => a && a.is_default).length;
    if (count > 0 && count !== 1) {
      setError('payment_links_accounts', {
        type: 'manual',
        message: '決済リンクのデフォルトは1つだけ選択してください。',
      });
    } else {
      clearErrors('payment_links_accounts');
    }
  }, [paymentLinksAccounts, setError, clearErrors]);

  return (
    <>
      <div style={{ margin: '80px' }}>
        <OnOffByScroll place="General" />
      </div>
      {!isAuth ? (
        <>
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
        </>
      ) : permissions.includes('admin') ||
        permissions.includes('instructor') ||
        permissions.includes('organizer') ? (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">指導者決済方法の更新</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <BreadCrumbs crumbs={CRUMBS} />
          <div className={classes.container}>
            <form
              method="POST"
              encType="multipart/form-data"
              onSubmit={onSubmit}
            >
              {bankFields.length > 0 && bankForm(bankFields)}
              {paypayFields.length > 0 && paypayForm(paypayFields)}
              {paymentLinksFields.length > 0 &&
                paymentLinksForm(paymentLinksFields)}
              {/* バリデーションエラーを表示 */}
              {errors.bank_accounts?.message && (
                <div className={classes.error}>
                  {errors.bank_accounts.message}
                </div>
              )}
              {errors.paypay_accounts?.message && (
                <div className={classes.error}>
                  {errors.paypay_accounts.message}
                </div>
              )}
              {errors.payment_links_accounts?.message && (
                <div className={classes.error}>
                  {errors.payment_links_accounts.message}
                </div>
              )}
              {/* ここまで */}
              <div className={classes.button}>
                <button type="submit">更新</button>
              </div>
            </form>
          </div>
        </>
      ) : permissions === 'null' ? (
        setTimeout(() => {
          window.location.reload(true);
        }, 500)
      ) : (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">指導者決済方法の更新</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <div className={classes.container}>権限がありません</div>
        </>
      )}
      <Footer />
    </>
  );
};
export default InstructorPaymentMethodUpdate;
